import { isSSR } from 'utils/isSSR';

export function isCWLEnabled() {
	return Boolean(isSSR() ? process.env.CONF_CWL_URL : globalThis?.window ? globalThis.window.CWL : false);
}

export function isCWLActive() {
	return globalThis?.window && !window?.CWL?.consent;
}

export function openCWLDialog(url?: string) {
	if (url && isCWLEnabled()) {
		// #if [DEV]
		// eslint-disable-next-line no-console
		console.log('Opening CWL dialog, does not work in development');
		// #endif
		globalThis.window.dispatchEvent(new CustomEvent('cwl:open-dialog', { detail: { url } }));
	}
}
